<template>
    <div class="network-accesses" :class="{loading: loading}">
        <fieldset>
            <legend class="no-margin">
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Network Accesses
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left"
                         v-if="!accessibleType && !accessibleId || networkAccesses.length === 0">
                        <button type="button" class="btn btn-success" @click="open(null)" :disabled="loading">
                            Grant Network Access
                        </button>
                    </div>
                </div>
            </legend>

            <div class="form-group text-right">
                <div class="checkbox">
                    <label>
                        <input v-model.boolean="archived"
                               type="checkbox"
                               id="archived"
                               name="archived">
                        Show Archived
                    </label>
                </div>
            </div>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':currentNetworkAccessId === listNetworkAccess.id}"
                   v-for="listNetworkAccess in networkAccesses"
                   @click="open(listNetworkAccess.id)">
                    <h4>
                        {{listNetworkAccess.accessible.fullName}}

                        <span v-if="listNetworkAccess.accessible.lease && listNetworkAccess.accessible.lease.unit">
                            (Apt: {{listNetworkAccess.accessible.lease.unit}})
                        </span>

                        <span v-if="listNetworkAccess.archivedLabel"
                              v-html="listNetworkAccess.archivedLabel"></span>

                        <span v-if="listNetworkAccess.hasSentEmailNotifications"
                              class="fa fa-bell text-green"
                              v-tooltip="'Notifications Sent'"></span>
                        <span v-else-if="listNetworkAccess.hasPendingEmailNotifications"
                              class="fa fa-bell-o text-yellow"
                              v-tooltip="'Notifications Scheduled'"></span>
                    </h4>
                </a>
            </div>
        </fieldset>

        <network-access ref="networkAccess"
                        :project-id="projectId"
                        :accessible-id="accessibleId"
                        :accessible-type="accessibleType"
                        :network-credential-id="networkCredentialId"
                        :network-access-id="currentNetworkAccessId"
                        :afterSave="afterSave">
            &nbsp;
        </network-access>
    </div>
</template>

<script>
    export default {
        props: {
            accessibles: {
                default: () => {
                    return [];
                },
                type: Array
            },

            accessibleType: {
                default: null,
                type: String
            },

            accessibleId: {
                default: null,
                type: String
            },

            networkCredentialId: {
                default: null,
                type: String
            },

            projectId: {
                required: true,
                type: String
            },
        },

        data(){
            return {
                archived: false,
                loading: true,
                networkCredential: {},
                networkAccesses: [],
                currentNetworkAccessId: null
            };
        },

        mounted(){
            return this.loadNetworkAccesses()
                .finally( () => {
                    this.loading = false;
                } );
        },

        watch: {
            archived(){
                this.loading = true;

                return this.loadNetworkAccesses()
                    .finally( () => {
                        this.loading = false;
                    } );
            }
        },

        methods: {
            loadNetworkAccesses(){
                var originalUrl, url;

                originalUrl = '/api/networkAccesses?withArchiving=true';
                url = originalUrl;

                if( _.isEmpty( this.accessibles ) ){
                    if( this.accessibleType ){
                        url += '&accessible_type=' + this.accessibleType;
                    }

                    if( this.accessibleId ){
                        url += '&accessible_id=' + this.accessibleId;
                    }
                }
                else{
                    // or[i][filter]=filterValue
                    _.forEach( this.accessibles, ( accessible, key ) => {
                        if( !accessible.accessible_type ){
                            console.error( 'Missing accessible_type in accessibles prop' );
                        }
                        else if( !accessible.accessible_id ){
                            console.error( 'Missing accessible_id in accessibles prop' );
                        }

                        url += '&or[' + key + '][accessible_type]=' + accessible.accessible_type;
                        url += '&or[' + key + '][accessible_id]=' + accessible.accessible_id;
                    } );
                }

                if( this.networkCredentialId ){
                    url += '&network_credential_id=' + this.networkCredentialId;
                }

                // One filter option is required
                if( originalUrl === url ){
                    throw new Error( 'No filter options selected' );
                }

                if( this.archived ){
                    url += '&archived=archived';
                }

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'networkAccesses', response.data.NetworkAccesses );
                    } )
                    .catch( this.$root.handleErrors );
            },

            open( networkAccessId ){
                this.currentNetworkAccessId = networkAccessId;

                this.$nextTick( () => {
                    this.$refs.networkAccess.openModal();
                } );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            },

            afterSave(){
                this.resetData();

                this.$nextTick( () => {
                    this.loadNetworkAccesses()
                        .finally( () => {
                            this.loading = false;
                        } );
                } );
            }
        }
    }
</script>
